import script from "./UserSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSetting.vue?vue&type=script&setup=true&lang=js"

import "./UserSetting.vue?vue&type=style&index=0&id=5bc580b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc580b2"]])

export default __exports__